<template>
  <section class="header">
    <div class="is-flex is-justify-content-space-between mt-4 mx-4">
      <div class="logo">
        <router-link v-if="isLocal" to="/login">
          <img src="@/assets/logos/logo.svg" />
        </router-link>
        <a v-else href="https://www.clearestate.com/">
          <img src="@/assets/logos/logo.svg" />
        </a>
      </div>
      <div class="is-flex is-justify-content-flex-end is-align-items-center has-gap-10">
        <span
          class="is-clickable has-text-primary has-text-centered is-size-5 has-text-weight-semibold"
          v-if="showHelpModalButton"
          @click="showHelpModal"
          :data-e2e="AuthCypressAttribute.login.buttons.HELP_ME_LOG_IN"
        >
          {{ $t('auth.help-me-log-in') }}
        </span>

        <LanguagePopoverSelect
          v-if="showLanguageButton"
          v-bind="$attrs"
          class="is-flex-grow-1 language-button"
        />
        <router-link
          v-if="showLoginButton"
          to="/login"
          :data-e2e="AuthCypressAttribute.login.buttons.HEADER_LOGIN"
        >
          <ButtonView class="is-primary" outlined>
            <span>{{ $t('auth.log-in') }}</span>
          </ButtonView>
        </router-link>
        <router-link
          v-if="showSignupButton"
          to="/signup"
          :data-e2e="AuthCypressAttribute.login.buttons.HEADER_SIGNUP"
        >
          <ButtonView class="is-primary" outlined>
            <span>{{ $t('auth.sign-up') }}</span>
          </ButtonView>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import { Env } from '/@/Env';
import { AuthCypressAttribute } from '/@/modules/auth/constants/AuthCypressAttribute';
import LanguagePopoverSelect from '@/modules/auth/components/stateful/LanguagePopoverSelect.vue';
import ButtonView from '@/modules/core/ui/components/wrappers/ButtonView.vue';
import { AuthRoute } from '@/modules/auth/routes/auth.routes';
import ModalService from '@/modules/core/ui/services/ModalService';
import HelpMeLogInModal from '@/modules/auth/components/presentational/HelpMeLogInModal.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'LoginHeader',
  components: { ButtonView, LanguagePopoverSelect },
  props: {
    showLoginButton: { type: Boolean, default: false },
    showSignupButton: { type: Boolean, default: false },
    showLanguageButton: { type: Boolean, default: false },
    showHelpModalButton: { type: Boolean, default: false }
  },
  static: {
    AuthCypressAttribute,
    AuthRoute
  },
  computed: {
    isLocal() {
      return Env.isLocal();
    }
  },
  methods: {
    showHelpModal() {
      ModalService.show({
        parent: this,
        component: HelpMeLogInModal,
        props: {},
        fullScreen: false
      });
    }
  }
};
</script>

<style scoped>
.header {
  .logo {
    width: var(--ce-140px);
  }

  .language-button {
    margin-left: var(--ce-0px) !important;
  }
}
</style>
